import { Background } from './backgroundColor';
export * from './backgroundColor';
export default Background;
